module.exports = __webpack_public_path__ + "35b2fa1c283b0364c9503812e4aa824e.fbx";